import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
          return;
        }

        // Match this block, rather than another inventory block elsewhere in the section.
        const inventoryBlocks = [...html.querySelectorAll('product-inventory')];
        const newInventory = inventoryBlocks.find((block) =>
          block.querySelector('.product-inventory__text')?.id === this.querySelector('.product-inventory__text')?.id
        ) ?? inventoryBlocks[0];
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });

        // An impossible size/colour combination has no selected variant. The Liquid
        // fallback can otherwise describe the product's first available variant.
        if (detail.resource === null) {
          const text = this.querySelector('.product-inventory__text');
          const icon = this.querySelector('.product-inventory__icon');
          if (text) text.textContent = newInventory.dataset.unavailableMessage ?? this.dataset.unavailableMessage;
          if (icon) {
            icon.className = 'svg-wrapper product-inventory__icon product-inventory__icon-out_of_stock';
          }
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
